import React, { useState } from 'react';
import { Tabs, Wrapper, useBreadcrumbRoutes } from '@maxtropy/components';
import EnergyDispatchOrder from './components/EnergyDispatchOrder';
import GasScheduleTable from './components/GasScheduleTable';
import styles from './index.module.scss';
import { useHasPermission } from '@/utils/utils';
import { PermissionsType } from '@/common/permissionsConst';
import { Empty } from 'antd';
import notAuthorized from '@/assets/images/notAuthorized.png';
const GasSchedulePage: React.FC = () => {
  const breadcrumbRoutes = useBreadcrumbRoutes();
  const [activeTab, setActiveTab] = useState<string>('gasSchedule');
  const hasGASSUPPLYSCHEDULE = useHasPermission(PermissionsType.B_GASSUPPLYSCHEDULE);
  const hasKINETICENERGYDISPATCHORDER = useHasPermission(PermissionsType.B_KINETICENERGYDISPATCHORDER);
  const tabItems = [
    ...(hasGASSUPPLYSCHEDULE
      ? [
          {
            key: 'gasSchedule',
            label: '供气日程表',
            children: <GasScheduleTable />,
          },
        ]
      : []),
    ...(hasKINETICENERGYDISPATCHORDER
      ? [
          {
            key: 'energyDispatch',
            label: '动能调度单',
            children: <EnergyDispatchOrder />,
          },
        ]
      : []),
  ];

  return (
    <Wrapper routes={[...(breadcrumbRoutes?.routes ?? [])]} className={styles.wrapper}>
      {tabItems.length === 0 ? (
        <Empty description="暂无数据权限" image={notAuthorized} />
      ) : (
        // 如果有权限，显示 Tabs
        <Tabs activeKey={activeTab} selectedLinePlacement="top" onChange={key => setActiveTab(key)} items={tabItems} />
      )}
    </Wrapper>
  );
};

export default GasSchedulePage;
